import {
    newFormIdAtom,
    newFormServiceTypeAtom,
} from '../../../../../State/Atoms/FormProps/FormPropsAtoms'
import {
    assetServiceTypesAtom,
    newFormAssetTypeAtom,
} from '../../../../../State/Atoms/AssetData/AssetDataAtoms'
import { useRecoilState } from 'recoil'

export const renderFormSubmit = () => {
    const [newFormId] = useRecoilState(newFormIdAtom)
    const [newFormServiceType] = useRecoilState(newFormServiceTypeAtom)
    const [newFormAssetType] = useRecoilState(newFormAssetTypeAtom)
    const submitChooseNewForm = () => {
        document.location = `/FormGeneric/form/${newFormId}/${newFormAssetType}/${newFormServiceType}`
    }
    return (
        newFormId > -1 && (
            <div>
                <button
                    className='btn btn-sm btn-success'
                    type='button'
                    onClick={submitChooseNewForm}
                    style={{ marginTop: '10px' }}
                >
                    Start
                </button>
            </div>
        )
    )
}
